<template lang="pug">
.month-select.ui.menu.secondary
  a.item.no-print(@click='prev()') {{texts[0]}}
  a.item.no-print(@click='prev(12)', v-if='mode==="months"') {{years_text[0]}}
  a.item.main {{date_start.format(texts[2])}}
  .right.menu
    a.item.no-print(@click='next(12)', v-if='mode==="months"') {{years_text[1]}}
    a.item.no-print(@click='next()') {{texts[1]}}
</template>

<script>
const modes = {
  months: ['上个月', '下个月', 'YYYY年MM月'],
  years: ['前一年', '后一年', 'YYYY年'],
}

export default {
  name: 'month-select',
  props: {
    value: null,
    mode: { type: String, default: 'months' },
  },
  data() {
    return {
      date_start: this.$moment(),
      date_end: this.$moment(),
    }
  },
  computed: {
    texts() {
      return modes[this.mode] || []
    },
    years_text() {
      return modes.years || []
    },
  },
  created() {
    this.init()
  },
  watch: {
    mode() {
      this.init()
    },
    date_start() {
      this.$emit('update:start', this.date_start)
    },
    date_end() {
      this.$emit('update:end', this.date_end)
    },
  },
  methods: {
    init() {
      const value = this.$moment(this.value).startOf(this.mode)
      this.date_start = value
      this.date_end = value.clone().add(1, this.mode)
    },
    next(amount = 1) {
      this.date_start = this.date_start.clone().add(amount, this.mode)
      this.date_end = this.date_start.clone().add(amount, this.mode).subtract(1, 'second')
    },
    prev(amount = 1) {
      this.date_start = this.date_start.clone().subtract(amount, this.mode)
      this.date_end = this.date_start.clone().add(amount, this.mode).subtract(1, 'second')
    },
  },
}
</script>



// WEBPACK FOOTER //
// MonthSelect.vue?2c41e1f0